import { render } from "./LoadingPlaceholder.vue?vue&type=template&id=d7d2f6d8&scoped=true"
import script from "./LoadingPlaceholder.vue?vue&type=script&lang=js"
export * from "./LoadingPlaceholder.vue?vue&type=script&lang=js"

import "./LoadingPlaceholder.vue?vue&type=style&index=0&id=d7d2f6d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7d2f6d8"]])

export default __exports__